import { observable } from 'mobx';
// import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useMount from '@src/utils/hooks/use-mount';
import locales from './locales';

class FiveSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  @observable isActive = false;
  coordinateList = [
    {
      id: locales[0].id,
      text: locales[0].content_text,
      imgOn: require('./images/on1.png'),
      imgCenter: require('./images/dahuojian.png')
    },
    {
      id: locales[1].id,
      text: locales[1].content_text,
      imgOn: require('./images/on2.png'),
      imgCenter: require('./images/zhencha.png')
    },
    {
      id: locales[2].id,
      text: locales[2].content_text,
      imgOn: require('./images/on3.png'),
      imgCenter: require('./images/xiuli.png')
    },
    {
      id: locales[3].id,
      text: locales[3].content_text,
      imgOn: require('./images/on4.png'),
      imgCenter: require('./images/wuzhaung.png')
    },
    {
      id: locales[4].id,
      text: locales[4].content_text,
      imgOn: require('./images/on5.png'),
      imgCenter: require('./images/youer.png')
    },
    {
      id: locales[5].id,
      text: locales[5].content_text,
      imgOn: require('./images/on6.png'),
      imgCenter: require('./images/zhaoqing.png')
    },
    {
      id: locales[6].id,
      text: locales[6].content_text,
      imgOn: require('./images/on7.png'),
      imgCenter: require('./images/danyao.png')
    }
  ];
  @observable active = 0;
  switchCoordinate(event, index) {
    // console.log('switchCoordinate');
    event.stopPropagation();
    this.active = index;
  }
  use() {
    useMount(() => {});
  }
}

export default FiveSectionStore;
